import { render, staticRenderFns } from "./Resonancia.vue?vue&type=template&id=2deced1b"
import script from "./Resonancia.vue?vue&type=script&lang=js"
export * from "./Resonancia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports